import React, { useEffect, useState } from "react"; // @ts-ignore
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import InsuranceStep from "../../../components/multistep/InsuranceStep";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import PersonalInformationStep from "../../../components/multistep/PersonalInformationStep";
import TermsStep from "../../../components/multistep/TermsStep";
import PaymentStep from "../../../components/multistep/PaymentStep";
import InsuranceReadyStep from "../../../components/multistep/InsuranceReadyStep";
import { useNavigate } from "react-router-dom";
import MaenadaAuthenticationQRInsurance from "../potential/MaenadaAuthenticationQRInsurance";

type ApplyWizardProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
  productName: string;
  amountOptions: any;
  durationOptions: any;
  termsAccepted: boolean;
};

const FormWizzard: React.FC<ApplyWizardProps> = (props) => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [insuranceAmount, setInsuranceAmount] = useState<string | undefined>(
    undefined,
  );
  const [durationContract, setDurationContract] = useState<string | undefined>(
    undefined,
  );
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    if (window.location.hash.startsWith("#payment")) {
      setActiveStep(4);
      setMounted(true);
      setTermsAccepted(false);
    } else {
      setMounted(true);
      setTermsAccepted(false);
    }

    return () => {
      setActiveStep(0);
      setMounted(false);
    };
  }, []);

  const handleComplete = () => {
    console.log("Form completed!");
    // Handle form completion logic here
    let path = `/insurance`;
    navigate(path);
  };

  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {
    prevIndex: number;
    nextIndex: number;
  }) => {};

  const updateInsuranceInformation = (amount: string, duration: string) => {
    setInsuranceAmount(amount);
    setDurationContract(duration);
  };

  const authenticateUser = () => {
    if (props.onApply) {
      props.onApply();
    }
  };

  const updateTermsAccepted = (checked: boolean) => {
    setTermsAccepted(checked);
  };

  const checkValidateTab = () => {
    return termsAccepted;
  };

  if (mounted) {
    return (
      <FormWizard
        onComplete={handleComplete}
        onTabChange={tabChanged}
        startIndex={activeStep}
      >
        <FormWizard.TabContent title="Insurance Information">
          <InsuranceStep
            payload={props.payload}
            signalIfValid={() => null}
            onUpdateInsuranceInfo={(amount, duration) =>
              updateInsuranceInformation(amount, duration)
            }
            amountOptions={props.amountOptions}
            durationOptions={props.durationOptions}
            selectedAmount={insuranceAmount}
            selectedDuration={durationContract}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Personal information">
          <PersonalInformationStep
            payload={props.payload}
            signalIfValid={() => null}
            authenticateUser={() => authenticateUser()}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Terms and Conditions">
          <TermsStep
            payload={props.payload}
            onTermsAccepted={(checked) => updateTermsAccepted(checked)}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Payment" isValid={checkValidateTab()}>
          <PaymentStep payload={props.payload} signalIfValid={() => null} />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Your Insurance">
          <InsuranceReadyStep
            payload={props.payload}
            signalIfValid={() => null}
            amount={insuranceAmount}
            duration={durationContract}
            insuranceName={props.productName}
          />
          {/* <MaenadaAuthenticationQRInsurance></MaenadaAuthenticationQRInsurance> */}
        </FormWizard.TabContent>
      </FormWizard>
    );
  }

  return null;
};

export default FormWizzard;
